import Reflux from 'reflux';

import { singletonActions, singletonStore } from 'logic/singleton';
import fetch from 'logic/rest/FetchProvider';
import { qualifyUrl } from 'util/URLUtils';
import PaginationURL from 'util/PaginationURL';
import type { Attributes } from 'stores/PaginationTypes';
import type { InstantArchive } from 'instant-archiving/Types';
import { INSTANT_ARCHIVING_API_ROUTES } from 'instant-archiving/Constants';

export type ActionsType = {
  searchPaginated: () => Promise<any>,
  updateConfig: () => Promise<any>,
};
const InstantArchivingActions = singletonActions('Streams', () => Reflux.createActions<ActionsType>({
  searchPaginated: { asyncResult: true },
  updateConfig: { asyncResult: true },
}));

type PaginatedResponse = {
  pagination: {
    count: number,
    total: number,
    page: number,
    per_page: number,
  },
  query: string,
  attributes: Attributes,
  elements: Array<InstantArchive>,
};

const InstantArchivingStore = singletonStore('InstantArchiving', () => Reflux.createStore({
  listenables: [InstantArchivingActions],

  callbacks: [],

  searchPaginated(newPage, newPerPage, newQuery, additional) {
    const url = PaginationURL(INSTANT_ARCHIVING_API_ROUTES.InstantArchivingAPIController.paginated().url, newPage, newPerPage, newQuery, additional);

    const promise = fetch('GET', qualifyUrl(url))
      .then((response: PaginatedResponse) => {
        const {
          elements,
          query,
          attributes,
          pagination: {
            count,
            total,
            page,
            per_page: perPage,
          },
        } = response;

        return {
          elements,
          attributes,
          pagination: {
            count,
            total,
            page,
            perPage,
            query,
          },
        };
      });

    InstantArchivingActions.searchPaginated.promise(promise);

    return promise;
  },
}));

export { InstantArchivingStore, InstantArchivingActions };
export default InstantArchivingStore;
